import { motion } from "framer-motion";
import { IMAGES, HASHTAG } from "@/lib/wedding-data";

const TILES = [
  { src: IMAGES.haldi, alt: "Vishi and Piyush at a haldi celebration", cls: "md:row-span-2 rounded-t-[100px]", pos: "object-center" },
  { src: IMAGES.lake, alt: "Vishi and Piyush by the lake", cls: "md:col-span-2", pos: "object-center" },
  { src: IMAGES.ethnic, alt: "Vishi and Piyush in evening ethnic wear", cls: "md:row-span-2", pos: "object-center" },
  { src: IMAGES.piggyback, alt: "A playful piggyback at the movies", cls: "", pos: "object-center" },
  { src: IMAGES.grandcanyon, alt: "Together at the Grand Canyon", cls: "", pos: "object-[50%_60%]" },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="scroll-mt-24 py-28 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-6">
              Moments
            </p>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-[#1A1A1A] leading-[1.05]">
              The story <span className="italic text-[#5D171E]">so far</span>
            </h2>
          </div>
          <p className="text-sm text-[#1A1A1A]/60 max-w-xs">
            Share your photographs from the celebrations with{" "}
            <span className="font-serif italic text-lg text-[#5D171E]">{HASHTAG}</span>
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 md:grid-flow-dense auto-rows-[180px] md:auto-rows-[220px] gap-4 md:gap-6">
          {TILES.map((t, i) => (
            <motion.div
              key={t.src}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className={`group relative overflow-hidden rounded-2xl ${t.cls}`}
            >
              <img
                src={t.src}
                alt={t.alt}
                loading="lazy"
                data-testid={`gallery-image-${i + 1}`}
                className={`h-full w-full object-cover ${t.pos} transition-transform duration-700 group-hover:scale-105`}
              />
              <div className="absolute inset-0 bg-[#5D171E]/0 group-hover:bg-[#5D171E]/20 transition-colors duration-500" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
